import CrossCircleIcon from '@atlaskit/icon/glyph/cross-circle';
import kebabCase from 'lodash/kebabCase';
import times from 'lodash/times';
import * as React from 'react';

interface LoadingPlaceholderRowsProps {
  numberOfRows: number;
  colSpan: number;
}

export const LoadingPlaceholderRows = ({ numberOfRows, colSpan }: LoadingPlaceholderRowsProps) => {
  return (
    <tbody data-testid="loading-placeholder-table">
      {times(numberOfRows, (i) => (
        <tr key={`loading-${i}`}>
          <td colSpan={colSpan} className="loading-placeholder" />
        </tr>
      ))}
    </tbody>
  );
};

interface StatusRowProps {
  colSpan: number;
}

export const StatusRow = ({ children, colSpan }: React.PropsWithChildren<StatusRowProps>) => {
  return (
    <tbody>
      <tr>
        <td colSpan={colSpan} className="search-state">
          {children}
        </td>
      </tr>
    </tbody>
  );
};

interface NoResultsRowProps {
  entitiesName: string;
  colSpan: number;
}

export const NoResultsRow = ({ entitiesName, colSpan }: NoResultsRowProps) => {
  return (
    <StatusRow colSpan={colSpan}>
      <span className="search-status no-results" data-testid={`no-results-row-${kebabCase(entitiesName)}`}>
        No {entitiesName} found
      </span>
    </StatusRow>
  );
};

interface ErrorRowProps {
  error: string | Error;
  colSpan: number;
}

export const ErrorRow = ({ error, colSpan }: ErrorRowProps) => {
  return (
    <StatusRow colSpan={colSpan}>
      <span className="search-status error-results" data-testid="error-row">
        <CrossCircleIcon label="Error" size="small" />
        Oh no! Something went wrong, please try again
        <span className="error">({error.toString()})</span>
      </span>
    </StatusRow>
  );
};

interface LoadMoreRowProps {
  colSpan: number;
  onLoadMoreClick: () => void;
  results?: unknown[];
  resultsCount?: number;
  totalHits: number;
}

export const LoadMoreRow = ({ colSpan, results, resultsCount, totalHits = 0, onLoadMoreClick }: LoadMoreRowProps) => {
  const handleLoadMoreClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    onLoadMoreClick();
  };

  const offsetCount = resultsCount ? resultsCount : 0;

  return (
    <StatusRow colSpan={colSpan}>
      <div className="load-more" data-testid="load-more-row">
        <a href="#" data-testid="load-more-row-btn" onClick={handleLoadMoreClick}>
          Load more...
        </a>
        {totalHits > 0 && (
          <span>
            (showing {results ? results.length + offsetCount : offsetCount} of {totalHits})
          </span>
        )}
      </div>
    </StatusRow>
  );
};
